import { Modal } from 'flowbite-react'
import React, { useEffect, useState } from 'react'
import Draggable from 'react-draggable'

interface IProps {
  show?: boolean
  size?:
    | 'sm'
    | 'md'
    | 'lg'
    | 'xl'
    | '2xl'
    | '3xl'
    | '4xl'
    | '5xl'
    | '6xl'
    | '7xl'
  position?:
    | 'center'
    | 'top-left'
    | 'top-center'
    | 'top-right'
    | 'center-left'
    | 'center-right'
    | 'bottom-right'
    | 'bottom-center'
    | 'bottom-left'
  header: React.ReactNode
  footer?: React.ReactNode
  children?: React.ReactNode
  onClose?: () => void
  className?: string
  draggable?: boolean
  headerClassName?: string
  bodyClassName?: string
  /**
   * Test-only seam. Grandfathered prop name (pre-Stage-6 convention); new components
   * use `testId` instead. React prop convention: `testId` (camelCase). DOM attribute:
   * `data-testid` (kebab-case). See e2e/readme.md §Conventions.
   */
  dataTestId?: string
}

const ModalComponent = ({
  children,
  header,
  footer,
  show = false,
  size = 'md',
  position = 'center',
  className = '',
  headerClassName = '',
  bodyClassName = '',
  onClose,
  draggable = false,
  dataTestId = ''
}: IProps) => {
  const [isBrowser, setIsBrowser] = useState(false)
  const y =
    typeof window !== 'undefined'
      ? (Math.floor(window.innerHeight / 2) - 55) * -1
      : 0

  useEffect(() => {
    setIsBrowser(typeof window !== 'undefined')
  }, [])

  const getModalContent = (isDraggable: boolean = false) => {
    return (
      <div data-testid={dataTestId}>
        <Modal.Header
          className={`m-0 ${headerClassName} ${
            isDraggable && `modal-header cursor-move`
          }`}
        >
          {header}
        </Modal.Header>
        <Modal.Body
          className={`bg-white rounded max-h-[78vh] overflow-y-auto ${bodyClassName}`}
        >
          {children}
        </Modal.Body>
        {footer && <Modal.Body className="border-t">{footer}</Modal.Body>}
      </div>
    )
  }

  return isBrowser ? (
    <Modal
      show={show}
      size={size}
      position={position}
      onClose={onClose}
      className={`${className}`}
    >
      {!draggable ? (
        getModalContent()
      ) : (
        <div className="relative">
          <Draggable handle=".modal-header" defaultPosition={{ x: 0, y }}>
            <div className="absolute w-full bg-white rounded-lg">
              {getModalContent(true)}
            </div>
          </Draggable>
        </div>
      )}
    </Modal>
  ) : (
    <></>
  )
}
export default ModalComponent
